import { Box, Container, Heading, Image, Link, Text } from "@chakra-ui/react";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import RP from "../img/related-property.png";
// Import Swiper styles
import "swiper/css";
import { propertyUrl } from "./Utils";
import {API_BASE_IMAGES} from "../OldApp";

const Related = ({ propertyDetail }) => {

  const [relatedProperty, setRelatedProperty] = useState([]);
  useEffect(() => {
    if (propertyDetail && propertyDetail.nearby_properties) {
      // Create an array of fetch promises
      const fetchPromises = propertyDetail.nearby_properties.map(pro =>
        fetch("/properties/" + pro.wtweb_id + ".json", { mode: "cors" })
          .then(response => response.json())
      );

      // When all fetch requests are complete
      Promise.all(fetchPromises)
        .then(data => {

          let newData = data.filter((stateProperty) => stateProperty.available === true);

          setRelatedProperty(prevProperties => [...prevProperties, ...newData]);
        })
        .catch(error => console.error(error));
    }
  }, [propertyDetail]);

  return (
    <Box>
      <Heading color={"DarkBlue"} fontSize={"5xl"} textAlign={"center"} mt={20} mb={16}>
        Nearby Properties
      </Heading>
      <Container maxW={"98%"} sx={{
        ".swiper-wrapper": {
          justifyContent: relatedProperty.length <= 2 ? "center" : ""
        }
      }}>

        <Swiper
          modules={[Autoplay]}
          // autoplay={{
          //   delay: 2500,
          //   disableOnInteraction: false,
          // }}
          // centeredSlides={true}
          // loop={true}
          breakpoints={{
            640: {
              slidesPerView: 1.5,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 100,
            },
          }}
        >
          {relatedProperty && (<>
            {relatedProperty.map((property, index) => (

              <SwiperSlide key={index}>
                <Box
                  overflow={"hidden"}
                  borderTopLeftRadius={"150px"}
                  pos={"relative"}

                //  boxShadow={"0px 0px 20px 0px rgbaH@mza@03323686588(0, 0, 0, 0.05)"}
                >
                  <Link href={propertyUrl(property)} pos={"relative"} zIndex={2} _after={{
                    content: `""`,
                    pos: "absolute",
                    bgGradient: "linear(to-t,#032946, #03294600)",
                    w: "100%",
                    h: "100%",
                    top: "100px",
                  }}>
                    <Image margin={"0 auto"} src={API_BASE_IMAGES + property?.photos?.[0]?.path_760} w={"100%"} h={"350px"} objectFit={"cover"} />
                    <Box px={4}>
                      <Text
                        pos={"absolute"}
                        bottom={4}
                        color={"white"}
                        fontSize={"md"}
                        zIndex={2}
                      >
                        {property.name}
                      </Text>
                    </Box>
                  </Link>
                </Box>
              </SwiperSlide>
            ))}
          </>)}

        </Swiper>
      </Container>
    </Box >
  );
};

export default Related;
